<template>
  <div class="field-number position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldNumber
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldNumber
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :disableLock="disableLock"
      :calculated="calculated"
      @input="$emit('input', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldNumber
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :parentItem="parentItem"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
      :lists="lists"
    />
  </div>
</template>

<script>
import EditFieldNumber from "./number/editField.vue";
import ViewFieldNumber from "./number/viewField.vue";
import FilterFieldNumber from "./number/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";

export default {
  name: "FieldNumber",
  mixins: [fieldEditableByMixin],
  components: {
    EditFieldNumber,
    ViewFieldNumber,
    FilterFieldNumber,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String, Array],
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    parentItem: {
      type: Object,
      default: null,
      validator: (value) => value === null || typeof value === 'object',
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    lists: {
      type: Array,
      default: () => [],
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    computedFieldId() {
      return this.fieldId || `field-number-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-number {
  width: 100%;
}
</style>
